export const getProductCardValueLine = (category) => {
  switch (category) {
    case "T-Shirts":
      return "Organic Cotton • Regular Fit";
    case "Jumpers":
      return "Cotton Blend • Relaxed Fit";
    case "Hats":
      return "Cotton Twill • Adjustable Fit";
    default:
      return "Premium Quality";
  }
};

export const getProductDetailValueLine = (category) => {
  switch (category) {
    case "T-Shirts":
      return "Premium Organic Cotton • Regular Fit";
    case "Jumpers":
      return "Heavyweight Cotton Blend • Relaxed Fit";
    case "Hats":
      return "Premium Cotton Twill • Adjustable Fit";
    default:
      return "Premium Quality • Everyday Fit";
  }
};
